module.exports = __webpack_public_path__ + "static/media/airpodspro2xmob.dbbaecbf.png";